interface ProgressBarProps {
  porcentaje: number
}

export function ProgressBar({ porcentaje }: ProgressBarProps) {
  return (
    <div className="flex items-center gap-2">
      <div className="flex-1 h-2 bg-teal-500/10 rounded-full overflow-hidden">
        <div
          className="h-full rounded-full transition-all"
          style={{ background: 'linear-gradient(90deg, #14b8a6, #0f766e)', width: `${porcentaje}%` }}
        />
      </div>
      <span className="text-xs text-muted-foreground w-8 text-right">{porcentaje}%</span>
    </div>
  )
}
